import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import Type from "./Type";
import ResumeNew from "../Resume/ResumeNew";
import Tilt from "react-parallax-tilt";

function Home() {

  return (


    <section  >
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hello Welcome!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  🤚
                </span>
              </h1>

              <h1 className="heading-name">
                I 'm
                <strong className="main-name"> Chaudhry Muaz</strong>
              </h1>


              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>

            </Col>

            <Col md={5} style={{ paddingBottom: 20, }}>
              <Tilt>
                <img className="img1"
                  src={require("../Home/me.jpeg")}
                  alt="add pic"

                />

              </Tilt>
            </Col>

          </Row>
        </Container>


      </Container>
      <ResumeNew />
      <Home2 />
    </section>
  );
}

export default Home;
